import * as IoC from 'typescript-ioc';
import { JobConfiguration } from '../../job-configuration';
import { JobType } from '../../../../api/jobs.dao';
import { IOrganizationsDAO } from '../../../../api/organizations.dao';

export class DeleteOrganizationJob extends JobConfiguration {
    public readonly type = JobType.DeleteOrganization;
    public readonly name = 'Delete Organization';
    public readonly description = 'Organization Deletion';

    public async execute(execParams) {
        return IoC.Container.get(IOrganizationsDAO).deleteOrganization(execParams);
    }
}

export default {
    [JobType.DeleteOrganization]: DeleteOrganizationJob
};
